// extracted by mini-css-extract-plugin
export default {"root":"styles_root__aWppa","rootMargin":"styles_rootMargin__GypN2"};